import React from "react"

import Consent from "../consent/Consent"

import { gaEvent, pushDataLayer } from "../../shared/helpers/gtm_tracking";

class CookieConsentBanner extends React.Component {
  constructor(props) {
    super(props)

    this.consent = new Consent(props.permCookieName, props.sessCookieName)

    this.state = {
      bannerClassName: "cookie-consent-banner",
      buttonClassName: "button button--alt--solid"
    }
  }

  componentDidMount() {
    const consent = this.consent

    if (!consent.hasSetConsent && !consent.hasUnknownConsent) {
      consent.setUnknownConsent(true)
    }
  }

  handleClick(consentState) {
    this.consent.set(consentState)
    this.trackCookieBannerConsent()

    const banner = document.querySelector(`.${this.state.bannerClassName}`)

    if (!banner) {
      return
    }

    banner.setAttribute("hidden", true)
  }

  trackCookieBannerConsent() {
    const consented = this.consent.get().consented

    gaEvent("All pages", "Cookie Banner", `Remarketing consent ${consented ? "given" : "refused"}`)
    if (consented) {
      const dynamicRemarketing = {
        hrental_id: window.location.pathname.split('/')[1],
        hrental_pagetype: "offerdetail"
      }

      pushDataLayer({ event: "dynamicRemarketing", dynamicRemarketing })
    }
  }

  render() {
    const consent = this.consent
    const state = this.state
    const hidden = consent.hasSetConsent || consent.hasUnknownConsent

    // we show the banner once per session if we don't have consent set
    return (
      <div
        className={state.bannerClassName}
        hidden={hidden || undefined}
      >
        <p>
          By browsing this site you accept cookies used to improve and personalise
          our services; if you click &apos;<strong>Accept &amp; Close</strong>&apos; we
          will also use cookies to personalise advertising on other sites. <br />
          Read our updated <a href="/privacy">privacy policy</a> for more about
          what we do with your data, as well as your rights and choices.
        </p>
        <div>
          <p>
            <button
              className={state.buttonClassName}
              title="I consent"
              onClick={() => { this.handleClick(true) }}
            >
              <strong>
                Accept &amp; Close
              </strong>
            </button>
          </p>
          <p>
            <a
              title="I do not consent"
              onClick={() => { this.handleClick(false) }}
            >
              <small>
                Reject personalised marketing
              </small>
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default CookieConsentBanner



// WEBPACK FOOTER //
// ./components/cookie_consent_banner/cookie_consent_banner.jsx